// SPDX-License-Identifier: AGPL-3.0-or-later
const DAY_MS = 86_400_000;
export function parseIsoDate(date) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
    if (!match)
        throw new Error(`Not an ISO date: ${date}`);
    return Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}
export function formatIsoDate(ms) {
    return new Date(ms).toISOString().slice(0, 10);
}
export function addDays(date, days) {
    return formatIsoDate(parseIsoDate(date) + days * DAY_MS);
}
export function daysBetween(from, to) {
    return Math.round((parseIsoDate(to) - parseIsoDate(from)) / DAY_MS);
}
export function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month, 0)).getUTCDate();
}
/** 0 = Sunday … 6 = Saturday. */
export function weekday(date) {
    return new Date(parseIsoDate(date)).getUTCDay();
}
export function yearOf(date) {
    return Number(date.slice(0, 4));
}
export function monthOf(date) {
    return Number(date.slice(5, 7));
}
export function isoDate(year, month, day) {
    return formatIsoDate(Date.UTC(year, month - 1, day));
}
/** Whole months from `from` to `to`, counting a partial month as one. */
export function monthsUntil(from, to) {
    const months = (yearOf(to) - yearOf(from)) * 12 + (monthOf(to) - monthOf(from));
    const dayFrom = Number(from.slice(8, 10));
    const dayTo = Number(to.slice(8, 10));
    return Math.max(0, dayTo > dayFrom ? months + 1 : months);
}
/** The same day `n` months later (or earlier), on the last day of shorter months. */
export function addMonths(date, n) {
    const index = yearOf(date) * 12 + monthOf(date) - 1 + n;
    const y = Math.floor(index / 12);
    const m = index - y * 12 + 1;
    return isoDate(y, m, Math.min(Number(date.slice(8, 10)), daysInMonth(y, m)));
}
//# sourceMappingURL=dates.js.map